import img01 from "./../../assets/GalleryImages/img01.JPG";
import img02 from "./../../assets/GalleryImages/img02.JPG";
import img03 from "./../../assets/GalleryImages/img03.JPG";
import img04 from "./../../assets/GalleryImages/img04.JPG";
import img05 from "./../../assets/GalleryImages/img05.JPG";
import img06 from "./../../assets/GalleryImages/img06.JPG";
import img07 from "./../../assets/GalleryImages/img07.JPG";
import img08 from "./../../assets/GalleryImages/img08.JPG";
import img09 from "./../../assets/GalleryImages/img09.JPG";
import img10 from "./../../assets/GalleryImages/img10.JPG";
import img11 from "./../../assets/GalleryImages/img11.JPG";
import img12 from "./../../assets/GalleryImages/img12.JPG";
import img13 from "./../../assets/GalleryImages/img13.JPG";
import img14 from "./../../assets/GalleryImages/img14.JPG";
import img15 from "./../../assets/GalleryImages/img15.JPG";
import img16 from "./../../assets/GalleryImages/img16.JPG";
import img17 from "./../../assets/GalleryImages/img17.JPG";
import img18 from "./../../assets/GalleryImages/img18.jpg";
import img19 from "./../../assets/GalleryImages/img19.JPG";
import img20 from "./../../assets/GalleryImages/img20.JPG";
import img21 from "./../../assets/GalleryImages/img21.JPG";
import img22 from "./../../assets/GalleryImages/img22.JPG";
import img23 from "./../../assets/GalleryImages/img23.JPG";
import img24 from "./../../assets/GalleryImages/img24.JPG";
import img25 from "./../../assets/GalleryImages/img25.JPG";
import img26 from "./../../assets/GalleryImages/img26.JPG";
import img27 from "./../../assets/GalleryImages/img27.JPG";
import img28 from "./../../assets/GalleryImages/img28.JPG";
import img29 from "./../../assets/GalleryImages/img29.JPG";
import img30 from "./../../assets/GalleryImages/img30.JPG";
import img31 from "./../../assets/GalleryImages/img31.JPG";
import img32 from "./../../assets/GalleryImages/img32.JPG";
import img33 from "./../../assets/GalleryImages/img33.jpg";
import img34 from "./../../assets/GalleryImages/img34.jpg";
import img35 from "./../../assets/GalleryImages/img35.jpg";
import img36 from "./../../assets/GalleryImages/img36.jpg";
import img37 from "./../../assets/GalleryImages/img37.jpg";
import img38 from "./../../assets/GalleryImages/img38.jpg";
import img39 from "./../../assets/GalleryImages/img39.jpg";
import img40 from "./../../assets/GalleryImages/img40.jpg";
import img41 from "./../../assets/GalleryImages/img41.jpg";
import img42 from "./../../assets/GalleryImages/img42.jpg";
import img43 from "./../../assets/GalleryImages/img43.jpg";
import img44 from "./../../assets/GalleryImages/img44.jpg";
import img45 from "./../../assets/GalleryImages/img45.jpg";
import img46 from "./../../assets/GalleryImages/img46.jpg";
import img47 from "./../../assets/GalleryImages/img47.jpg";
import img48 from "./../../assets/GalleryImages/img48.jpg";
import img49 from "./../../assets/GalleryImages/img49.jpg";
import img50 from "./../../assets/GalleryImages/img50.jpg";

export const IMAGES = [
    {
        src: img01,
        thumbnail: "https://live.staticflickr.com/65535/52310746769_77c301d7d7_t.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img02,
        thumbnail: img02,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img03,
        thumbnail: img03,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img04,
        thumbnail: img04,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img05,
        thumbnail: img05,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img06,
        thumbnail: img06,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img07,
        thumbnail: img07,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img08,
        thumbnail: img08,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img09,
        thumbnail: img09,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img10,
        thumbnail: img10,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img11,
        thumbnail: img11,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img12,
        thumbnail: img12,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img13,
        thumbnail: img13,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img14,
        thumbnail: img14,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img15,
        thumbnail: img15,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img16,
        thumbnail: img16,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img17,
        thumbnail: img17,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img18,
        thumbnail: img18,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img19,
        thumbnail: img19,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img20,
        thumbnail: img20,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img21,
        thumbnail: img21,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img22,
        thumbnail: img22,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img23,
        thumbnail: img23,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img24,
        thumbnail: img24,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img25,
        thumbnail: img25,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img26,
        thumbnail: img26,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img27,
        thumbnail: img27,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img28,
        thumbnail: img28,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img29,
        thumbnail: img29,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img30,
        thumbnail: img30,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img31,
        thumbnail: img31,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img32,
        thumbnail: img32,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img33,
        thumbnail: img33,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img34,
        thumbnail: img34,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img35,
        thumbnail: img35,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img36,
        thumbnail: img36,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img37,
        thumbnail: img37,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img38,
        thumbnail: img38,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img39,
        thumbnail: img39,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img40,
        thumbnail: img40,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img41,
        thumbnail: img41,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img42,
        thumbnail: img42,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img43,
        thumbnail: img43,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img44,
        thumbnail: img44,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img45,
        thumbnail: img45,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img46,
        thumbnail: img46,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img47,
        thumbnail: img47,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img48,
        thumbnail: img48,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img49,
        thumbnail: img49,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: img50,
        thumbnail: img50,
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/gjFLftYs/DSC0101.jpg",
        thumbnail: "https://i.postimg.cc/gjFLftYs/DSC0101.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/Jz4HVkWf/IMG-2296.jpg",
        thumbnail: "https://i.postimg.cc/Jz4HVkWf/IMG-2296.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/yxj6vLWk/IMG-2313.jpg",
        thumbnail: "https://i.postimg.cc/yxj6vLWk/IMG-2313.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/MH9xyXrB/DSC0052.jpg",
        thumbnail: "https://i.postimg.cc/MH9xyXrB/DSC0052.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/FzHXsNsH/IMG-2388.jpg",
        thumbnail: "https://i.postimg.cc/FzHXsNsH/IMG-2388.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/SN2kXLpL/IMG-2250.jpg",
        thumbnail: "https://i.postimg.cc/SN2kXLpL/IMG-2250.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/PfFdr30r/IMG-2124.jpg",
        thumbnail: "https://i.postimg.cc/PfFdr30r/IMG-2124.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/Kz3hKF6G/IMG-2221.jpg",
        thumbnail: "https://i.postimg.cc/Kz3hKF6G/IMG-2221.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/TYVGqdph/IMG-2128.jpg",
        thumbnail: "https://i.postimg.cc/TYVGqdph/IMG-2128.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/4NY38MSC/Whats-App-Image-2022-07-18-at-6-45-41-PM.jpg",
        thumbnail: "https://i.postimg.cc/4NY38MSC/Whats-App-Image-2022-07-18-at-6-45-41-PM.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/RVZCD0Xb/2.jpg",
        thumbnail: "https://i.postimg.cc/RVZCD0Xb/2.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/RF1fX0XZ/3.jpg",
        thumbnail: "https://i.postimg.cc/RF1fX0XZ/3.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/zXyvfBKH/4.jpg",
        thumbnail: "https://i.postimg.cc/zXyvfBKH/4.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/wB8SS6hm/5.jpg",
        thumbnail: "https://i.postimg.cc/wB8SS6hm/5.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/1tPTWJph/6.jpg",
        thumbnail: "https://i.postimg.cc/1tPTWJph/6.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/g2HBx3Cg/7.jpg",
        thumbnail: "https://i.postimg.cc/g2HBx3Cg/7.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/pr56r4vj/8.jpg",
        thumbnail: "https://i.postimg.cc/pr56r4vj/8.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/SKp2vMjb/9.jpg",
        thumbnail: "https://i.postimg.cc/SKp2vMjb/9.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/W10CvBpq/10.jpg",
        thumbnail: "https://i.postimg.cc/W10CvBpq/10.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/g26XkK1Z/11.jpg",
        thumbnail: "https://i.postimg.cc/g26XkK1Z/11.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/hPVvkGmL/12.jpg",
        thumbnail: "https://i.postimg.cc/hPVvkGmL/12.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/nzsc0VZQ/13.jpg",
        thumbnail: "https://i.postimg.cc/nzsc0VZQ/13.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/s2xVgfM0/14.jpg",
        thumbnail: "https://i.postimg.cc/s2xVgfM0/14.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/05YqxKty/15.jpg",
        thumbnail: "https://i.postimg.cc/05YqxKty/15.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/hj0MZnrc/16.jpg",
        thumbnail: "https://i.postimg.cc/hj0MZnrc/16.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/nrysvjDz/17.jpg",
        thumbnail: "https://i.postimg.cc/nrysvjDz/17.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/zB336Swv/18.jpg",
        thumbnail: "https://i.postimg.cc/zB336Swv/18.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/vH5j16f4/20220423043441-IMG-7183.jpg",
        thumbnail: "https://i.postimg.cc/vH5j16f4/20220423043441-IMG-7183.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/02gZtgVF/20220423044003-IMG-7193.jpg",
        thumbnail: "https://i.postimg.cc/02gZtgVF/20220423044003-IMG-7193.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/rm3fBj4w/20220423044618-IMG-7209.jpg",
        thumbnail: "https://i.postimg.cc/rm3fBj4w/20220423044618-IMG-7209.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/bNJQxkS6/20220423045753-IMG-7229.jpg",
        thumbnail: "https://i.postimg.cc/bNJQxkS6/20220423045753-IMG-7229.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/B62RqRBV/Untitled-design-12.png",
        thumbnail: "https://i.postimg.cc/B62RqRBV/Untitled-design-12.png",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/hv5LNt7W/Untitled-design-13.png",
        thumbnail: "https://i.postimg.cc/hv5LNt7W/Untitled-design-13.png",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/D0X0yvMK/20220423-224612-0000.png",
        thumbnail: "https://i.postimg.cc/D0X0yvMK/20220423-224612-0000.png",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/L4nyRJmZ/20220423044207-IMG-7196.jpg",
        thumbnail: "https://i.postimg.cc/L4nyRJmZ/20220423044207-IMG-7196.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/65KGcPb5/IMG-20220424-170645.jpg",
        thumbnail: "https://i.postimg.cc/65KGcPb5/IMG-20220424-170645.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/nVBDvxkP/20220423045551-IMG-7228.jpg",
        thumbnail: "https://i.postimg.cc/nVBDvxkP/20220423045551-IMG-7228.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/DyZHm7Lt/IMG-2215.jpg",
        thumbnail: "https://i.postimg.cc/DyZHm7Lt/IMG-2215.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/C5Hc6QyT/IMG-2218.jpg",
        thumbnail: "https://i.postimg.cc/C5Hc6QyT/IMG-2218.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/pLxZpH9D/IMG-3451.jpg",
        thumbnail: "https://i.postimg.cc/pLxZpH9D/IMG-3451.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/5y6rKM5H/IMG-3449.jpg",
        thumbnail: "https://i.postimg.cc/5y6rKM5H/IMG-3449.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/zDHZknxx/IMG-3491.jpg",
        thumbnail: "https://i.postimg.cc/zDHZknxx/IMG-3491.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/fTxb848q/IMG-3578.jpg",
        thumbnail: "https://i.postimg.cc/fTxb848q/IMG-3578.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/3RDdH5fD/IMG-3473.jpg",
        thumbnail: "https://i.postimg.cc/3RDdH5fD/IMG-3473.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/3rmzdSPj/IMG-3464.jpg",
        thumbnail: "https://i.postimg.cc/3rmzdSPj/IMG-3464.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/SxgxHNdK/IMG-3505.jpg",
        thumbnail: "https://i.postimg.cc/SxgxHNdK/IMG-3505.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    },
    {
        src: "https://i.postimg.cc/Ss2LJPRW/IMG-3403.jpg",
        thumbnail: "https://i.postimg.cc/Ss2LJPRW/IMG-3403.jpg",
        thumbnailWidth: 500,
        thumbnailHeight: 350
    }
]

    // < a data-flickr - embed="true" href = "https://www.flickr.com/photos/196355393@N07/52310746769/in/dateposted-public/" title = "Untitled" ><img src="https://live.staticflickr.com/65535/52310746769_77c301d7d7_t.jpg" width="71" height="100" alt="Untitled"></a><script async src="//embedr.flickr.com/assets/client-code.js" charset="utf-8"></script>